import React from "react";
import PropTypes from "prop-types";
import { images } from "../../../assets";

const UrbcLogoWhite = ({ className }) => {
   return <img className={className} src={images.urbcLogoWhite} height="100" />;
};

UrbcLogoWhite.propTypes = {
   className: PropTypes.string,
};

export default UrbcLogoWhite;
